import type { StatsIntervalIds } from 'types/client/stats';

export const STATS_INTERVALS: { [key in StatsIntervalIds]: { title: string; start?: Date } } = {
  all: {
    title: '全部时间',
  },
  oneMonth: {
    title: '1 个月',
    start: getStartDateInPast(1),
  },
  threeMonths: {
    title: '3 个月',
    start: getStartDateInPast(3),
  },
  sixMonths: {
    title: '6 个月',
    start: getStartDateInPast(6),
  },
  oneYear: {
    title: '1 年',
    start: getStartDateInPast(12),
  },
};

function getStartDateInPast(months: number): Date {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date;
}
